<template>
  <div>
    <div v-for="(item, index) in info" :key="index">
      <div
        :class="[
          'public_style',
          item.tplnum === 'TJ01' || item.tplnum === 'TJ09'
            ? 'right_info'
            : 'life_info',
          item.tplnum === 'TJ09' && 'xianzhi'
        ]"
        v-if="
          item.tplnum === 'TJ01' ||
            item.tplnum === 'TJ03' ||
            item.tplnum === 'TJ09'
        "
      >
        <h5>{{ item.tpltitle }}</h5>
        <ul>
          <li
            v-for="(i, n) in item.data"
            :key="n"
            :title="i.jianjie"
            @click.stop="jump(i.url)"
          >
            {{ i.title }}
          </li>
        </ul>
      </div>
      <div
        :class="[
          item.tplnum === 'TJ02'
            ? 'picfont'
            : item.tplnum === 'TJ04'
            ? 'picfont2'
            : 'loupan',
          'public_style'
        ]"
        v-if="
          item.tplnum === 'TJ02' ||
            item.tplnum === 'TJ04' ||
            item.tplnum === 'TJ06'
        "
      >
        <h5 v-if="item.tplnum === 'TJ06'">{{ item.tpltitle }}</h5>
        <ul>
          <li v-for="(i, n) in item.data" :key="n" @click.stop="jump(i.url)">
            <img :src="picUrl+i.pic" />
            <div>
              <h2>{{ i.title }}</h2>
              <p>{{ i.jianjie }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div
        :class="[item.tplnum === 'TJ05' && 'imgAll', 'public_style']"
        v-if="item.tplnum === 'TJ05'"
      >
        <div
          class="div_f div_po"
          :title="item.data[0].jianjie"
          @click.stop="jump(item.data[0].url)"
        >
          <img class="img1" :src="picUrl+item.data[0].pic" />
          <span>{{ item.data[0].title }}</span>
        </div>
        <div class="div_f">
          <div
            class="div_po"
            :title="item.data[1].jianjie"
            @click.stop="jump(item.data[0].url)"
          >
            <img class="img2" :src="picUrl+item.data[1].pic" />
            <span>{{ item.data[1].title }}</span>
          </div>
          <div
            class="div_po"
            :title="item.data[2].jianjie"
            @click.stop="jump(item.data[0].url)"
          >
            <img class="img3" :src="picUrl+item.data[2].pic" />
            <span>{{ item.data[2].title }}</span>
          </div>
        </div>
      </div>
    <div class="houseTwo"  v-if="item.tplnum === 'TJ07'">
      <ul>
        <li v-for="(i,n) in item.data" :key="n">
          <h2>{{i.title}}</h2>
          <img :src="picUrl+i.pic" />
          <div>
            <!-- <h3>哈哈</h3>
            <p>￥38万</p> -->
            <p>{{i.jianjie}}</p>
          </div>
        </li>
      </ul>
    </div>
      <div class="specialSale" v-if="item.tplnum === 'TJ08'">
        <p v-for="(i, n) in item.data" :key="n" @click.stop="jump(i.url)">
          {{ i.title }}
        </p>
      </div>
      <div
        :class="[item.tplnum === 'TJ10' && 'carAd', 'public_style']"
        v-if="item.tplnum === 'TJ10'"
      >
        <ul>
          <li v-for="(i, n) in item.data" :key="n" @click.stop="jump(i.url)">
             <img :src="picUrl+i.pic" />
            <div>
              <h2>{{ i.title }}</h2>
              <p>{{ i.jianjie }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/axios/url'
import { getTuijianList } from '@/axios/api'
import sign from '@/auth/sign'
export default {
  data () {
    return {
      picUrl: url.picUrl,
      info: []
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      let oneParams = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000)
      }
      oneParams.sign = sign(oneParams)
      getTuijianList(oneParams).then(res => {
        this.info = res.data.data
      })
    },
    jump (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/recomendRight2.css";
</style>



// WEBPACK FOOTER //
// src/components/common/Right.vue